module.exports = __webpack_public_path__ + "img/teigtaschenschweinefleisch.8a71ee0b.jpg";